<template>
  <tr class="text-center">
    <td>
      {{ index+1<=9 ? '0' : '' }}{{ index+1 }}
    </td>
    <td>
      <div class="fw-bolder"> {{ item?.name }} </div>
    </td>
    <td> {{ item?.quantity }} </td>
    <td> {{ $formatLocalAmount(item?.price) }} </td>
    <td> {{ itemDiscount ? '-' : '' }} {{ $formatLocalAmount(itemDiscount) }} </td>
    <td> {{ $formatLocalAmount(ttcAmount) }}</td>
    <td> {{ $formatLocalAmount(totalTtc) }}  {{ currency }}</td>
  </tr>
</template>

<script setup>
import {computed, defineProps} from "vue";

const props = defineProps({
  item: Object,
  index: Number,
  currency: String
})

import {$formatLocalAmount, applyDiscount} from "@/mixins/Helpers";

const itemDiscount = computed(() => {
  if(props?.item.discount_value) {
    return applyDiscount(props.item?.discount_type, props.item?.discount_value, props?.item.price * props?.item.quantity)
  }
  return 0
})
const itemAmount = computed(() =>{
  return  props.item?.price * props.item?.quantity - itemDiscount.value
})

const ttcAmount = computed(() => {
  if (props.item?.taxes?.length > 0) {
    const totalTaxesPrice = props.item?.taxes?.reduce((accumulator, tax) => {
      if (tax.type === 'amount') {
        accumulator.accAmount += parseFloat(tax.amount);
      } else {
        accumulator.accPercent += (itemAmount.value * parseFloat(tax.amount) / 100);
      }
      return accumulator;
    }, { accAmount: 0, accPercent: 0 });
    return totalTaxesPrice.accAmount + totalTaxesPrice.accPercent;
  }
  return 0
})

const totalTtc = computed(() => itemAmount.value + ttcAmount.value)
</script>

<style scoped>

</style>
